import React from 'react';

const Products = () => {
  return (
    <section className="flex flex-col w-full justify-between px-4 py-[48px] min-h-screen bg-[#FEFF02] box-border">
      <div className="text-center text-[32px] font-bold text-black mb-6">PRODUKTY:</div>

      <div className="flex flex-col max-w-[1440px] w-full mx-auto gap-[40px] box-border">

        {/* Koszulka #1 */}
        <div className="flex flex-row mq450:flex-col w-full gap-5 items-center box-border">
          <div className="flex-1 mq450:hidden h-[400px]">
            <video autoPlay muted playsInline loop preload="auto" className="w-full h-full object-contain">
              <source src="/videos/video3.mp4" type="video/mp4" />
              Twoja przeglądarka nie obsługuje elementu video.
            </video>
          </div>
          <div className="hidden mq450:flex flex-col w-full">
            <video autoPlay muted playsInline loop preload="auto" className="w-full h-[300px] object-contain">
              <source src="/videos/tee-1-front.webm" type="video/webm" />
            </video>
            <video autoPlay muted playsInline loop preload="auto" className="w-full h-[300px] object-contain">
              <source src="/videos/tee-1-back.webm" type="video/webm" />
            </video>
          </div>

          <div className="flex-1 mq450:w-full flex flex-col justify-center gap-4 box-border">
            <div className="text-[24px] font-bold text-left mq450:text-center">Koszulka - F*** YOUR SYSTEM</div>
            <div className="bg-black text-white p-4 text-left mq450:text-center text-[18px] mq1024:text-[16px] leading-[1.5] w-full box-border">
              <b>Materiał:</b> 100% bawełna<br />
              <b>Gramatura:</b> 210g<br />
              <b>Krój:</b> Oversize<br />
              <b>Rozmiary:</b> S - XXL
            </div>
            <div
              className="mq450:hidden bg-black text-white px-4 py-2 uppercase font-bold text-[18px] w-auto self-start text-center"
            >
              WYPRZEDANE
            </div>
            <div
              className="hidden mq450:flex w-auto h-[48px] bg-black text-white px-4 py-2 uppercase font-bold text-[18px] items-center justify-center "
            >
              WYPRZEDANE
            </div>
          </div>
        </div>

        {/* Koszulka #2 */}
        <div className="flex flex-row mq450:flex-col w-full gap-5 items-center box-border">
          <div className="flex-1 mq450:hidden h-[400px]">
            <video autoPlay muted playsInline loop preload="auto" className="w-full h-full object-contain">
              <source src="/videos/video2.mp4" type="video/mp4" />
              Twoja przeglądarka nie obsługuje elementu video.
            </video>
          </div>
          <div className="hidden mq450:flex flex-col w-full">
            <video autoPlay muted playsInline loop preload="auto" className="w-full h-[300px] object-contain">
              <source src="/videos/tee-2-front.webm" type="video/webm" />
            </video>
            <video autoPlay muted playsInline loop preload="auto" className="w-full h-[300px] object-contain">
              <source src="/videos/tee-2-back.webm" type="video/webm" />
            </video>
          </div>

          <div className="flex-1 mq450:w-full flex flex-col justify-center gap-4 box-border">
            <div className="text-[24px] font-bold text-left mq450:text-center">Koszulka - Anonymous & Demon</div>
            <div className="bg-black text-white p-4 text-left mq450:text-center text-[18px] mq1024:text-[16px] leading-[1.5] w-full box-border">
              <b>Materiał:</b> 100% bawełna<br />
              <b>Gramatura:</b> 210g<br />
              <b>Krój:</b> Oversize<br />
              <b>Rozmiary:</b> S - XXL
            </div>
            <div
              className="mq450:hidden bg-black text-white px-4 py-2 uppercase font-bold text-[18px] w-auto self-start text-center"
            >
              WYPRZEDANE
            </div>
            <div
              className="hidden mq450:flex w-auto h-[48px] bg-black text-white px-4 py-2 uppercase font-bold text-[18px] items-center justify-center "
            >
              WYPRZEDANE
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Products;
